export default "__VITE_ASSET__906e8e8a__"